// src/components/finance/steps/EmploymentStep.jsx
import React, { useState } from 'react';
import '../../../styles/LoanSteps.css';

const EmploymentStep = ({ data, onNext, onPrevious, loading }) => {
  const [formData, setFormData] = useState({
    employment_type: data.employment_type || '',
    employer_name: data.employer_name || '',
    monthly_income: data.monthly_income || '',
    job_duration_months: data.job_duration_months || '',
    total_experience_months: data.total_experience_months || ''
  });

  const [errors, setErrors] = useState({});

  const employmentTypes = [
    { value: 'salaried', label: 'Salaried', icon: '💼' },
    { value: 'self_employed', label: 'Self-employed', icon: '🏢' },
    { value: 'homemaker', label: 'Homemaker', icon: '🏠' }
  ];

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
    setErrors({ ...errors, [field]: '' });
  };

  const validate = () => {
    const newErrors = {};
    
    if (!formData.employment_type) newErrors.employment_type = 'Employment type is required';
    if (formData.employment_type === 'salaried' && !formData.employer_name) {
      newErrors.employer_name = 'Employer name is required';
    }
    if (!formData.job_duration_months) newErrors.job_duration_months = 'Job duration is required';
    if (!formData.total_experience_months) newErrors.total_experience_months = 'Total experience is required';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      onNext(formData);
    }
  };

  return (
    <div className="step-container">
      <div className="step-header">
        <h3>Employment type</h3>
        <p>Pick one to help us tailor our services for you</p>
      </div>

      <form onSubmit={handleSubmit} className="step-form">
        <div className="employment-type-grid">
          {employmentTypes.map(type => (
            <button
              key={type.value}
              type="button"
              className={`employment-type-card ${formData.employment_type === type.value ? 'selected' : ''}`}
              onClick={() => handleChange('employment_type', type.value)}
            >
              <span className="employment-icon">{type.icon}</span>
              <span className="employment-label">{type.label}</span>
            </button>
          ))}
        </div>
        {errors.employment_type && <span className="error-text">{errors.employment_type}</span>}

        {formData.employment_type === 'salaried' && (
          <div className="form-group">
            <label>Employer Name (Optional)</label>
            <input
              type="text"
              value={formData.employer_name}
              onChange={(e) => handleChange('employer_name', e.target.value)}
              placeholder="Company name"
            />
          </div>
        )}

        {formData.employment_type && (
        <div className="form-group">
          <label>Monthly Income (₹)</label>
          <input
            type="number"
            value={formData.monthly_income}
            onChange={(e) => handleChange('monthly_income', e.target.value)}
            placeholder="30000"
            min="0"
            className={errors.monthly_income ? 'error' : ''}
          />
          {errors.monthly_income && (
            <span className="error-text">{errors.monthly_income}</span>
          )}
        </div>
      )}


        {formData.employment_type && (
          <>
            <div className="form-group">
              <label>Duration of employment at current organisation (In months)</label>
              <input
                type="number"
                value={formData.job_duration_months}
                onChange={(e) => handleChange('job_duration_months', e.target.value)}
                placeholder="e.g., 24"
                min="0"
                className={errors.job_duration_months ? 'error' : ''}
              />
              {errors.job_duration_months && <span className="error-text">{errors.job_duration_months}</span>}
            </div>

            <div className="form-group">
              <label>Total work experience (In months)</label>
              <input
                type="number"
                value={formData.total_experience_months}
                onChange={(e) => handleChange('total_experience_months', e.target.value)}
                placeholder="e.g., 36"
                min="0"
                className={errors.total_experience_months ? 'error' : ''}
              />
              {errors.total_experience_months && <span className="error-text">{errors.total_experience_months}</span>}
            </div>
          </>
        )}

        <div className="button-group">
          <button type="button" onClick={onPrevious} className="previous-button">
            Previous
          </button>
          <button 
            type="submit" 
            className="next-button" 
            disabled={loading || !formData.employment_type}
          >
            {loading ? 'Processing...' : 'Proceed'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EmploymentStep;